import React, { useState } from "react";
import { Navbar, Container, Nav, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Search } from "react-bootstrap-icons";

export default function Menu({ icon, menu, search, clean, placeholderSearch }) {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState("");
    const handleSearchChange = (event) => {
        event.preventDefault();
        setSearchValue(event.target.value);
    };
    const handleInput = (event) => {
        if (event.target.value === "") {
            clean();
        }
    };
    const handleFormSubmit = (event) => {
        event.preventDefault();
        console.log("Searching for:", searchValue);
        search(searchValue);
    };

    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container fluid>
                {icon && <Navbar.Brand className="menu-icon">{icon}</Navbar.Brand>}
                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav className="me-auto my-2 my-lg-0" navbarScroll>
                        {menu &&
                            menu.map((item, index) =>
                                item.type === "button" ? (
                                    <Button
                                        className="me-2"
                                        key={index}
                                        variant={item.variant || "primary"}
                                        onClick={item.action}
                                    >
                                        {item.icon && (
                                            <span className="me-3">
                                                {item.icon}
                                            </span>
                                        )}
                                        {t(item.label)}
                                    </Button>
                                ) : (
                                    <Nav.Link key={index} onClick={item.action}>
                                        {t(item.label)}
                                    </Nav.Link>
                                )
                            )}
                    </Nav>
                    {search && (
                        <Form className="d-flex" onSubmit={handleFormSubmit}>
                            <Form.Control
                                type="search"
                                placeholder={t(placeholderSearch)}
                                className="me-2"
                                aria-label="Search"
                                onChange={handleSearchChange}
                                onInput={handleInput}
                            />
                            <Button variant="outline-success" type="submit">
                                <Search />
                            </Button>
                        </Form>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}
